var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 139,
    viewBox: "0 0 108 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.286 0C102.332 0 104.294 0.813589 105.741 2.26179C107.187 3.70998 108 5.67416 108 7.72222V131.278C108 133.326 107.187 135.29 105.741 136.738C104.294 138.186 102.332 139 100.286 139H7.71429C5.66833 139 3.70617 138.186 2.25946 136.738C0.812751 135.29 0 133.326 0 131.278V7.72222C0 5.67416 0.812751 3.70998 2.25946 2.26179C3.70617 0.813589 5.66833 0 7.71429 0H100.286ZM92.5714 15.4444H15.4286V123.556H92.5714V15.4444ZM77.1429 61.7778V77.2222H61.7143V61.7778H77.1429Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoors);
export default __webpack_public_path__ + "static/media/doors.397bf82c9125111c6e0156b0a845b285.svg";
export { ForwardRef as ReactComponent };